import { render, staticRenderFns } from "./PostLikeList.vue?vue&type=template&id=e8f86f60&"
import script from "./PostLikeList.vue?vue&type=script&lang=ts&"
export * from "./PostLikeList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports